export default __webpack_public_path__ + "static/fingerprint-bg-b619a135186690120977ee0f8b9f38cd.svg";